import * as i0 from "@angular/core";
export class LoginStore {
}
LoginStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoginStore_Factory() { return new LoginStore(); }, token: LoginStore, providedIn: "root" });
export var LoginStoreKeys;
(function (LoginStoreKeys) {
})(LoginStoreKeys || (LoginStoreKeys = {}));
